module.exports = __webpack_public_path__ + "img/CYB.dcb6c9fc.png";